import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';

class LocationForm extends Component {
  static validate = (values) => {
    const errors = {};
    const requiredFields = ['name','street','city','state','zip'];

    requiredFields.forEach((item) => {
      if (!values[item]) {
        errors[item] = 'Required';
      }
    });

    return errors;
  }

  renderTextField = props => (
    <TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...props} fullWidth />
  );

  render() {
    const { handleSubmit, submitting } = this.props;
    const buttonText = (submitting) ? 'Saving...' : 'Save';

    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col s12">
            <Field name="name" label="Location Name" component={this.renderTextField} />
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <Field name="street" label="Address" component={this.renderTextField} />
          </div>
        </div>
        <div className="row">
          <div className="col s12">
            <Field name="street2" label="Unit, Suite, etc." component={this.renderTextField} />
          </div>
        </div>
        <div className="row">
          <div className="col s12 m6">
            <Field name="city" label="City" component={this.renderTextField} />
          </div>
          <div className="col s12 m4">
            <Field name="state" label="State" component={this.renderTextField} />
          </div>
          <div className="col s12 m2">
            <Field name="zip" label="Zip Code" component={this.renderTextField} />
          </div>
        </div>
        <div className="row">
          <div className="col s12 m8" />
          <div className="col s12 m4">
            <RaisedButton fullWidth onClick={handleSubmit} disabled={submitting}>{buttonText}</RaisedButton>
          </div>
        </div>
      </form>
    );
  }
}


export default reduxForm({
  form: 'locationForm',
  validate: LocationForm.validate
})(LocationForm);


// WEBPACK FOOTER //
// ./src/components/Locations/Edit.js